import React from 'react';
import {
  Box,
  Typography,
  Card,
  Chip,
  IconButton,
  TableContainer,
  Table,
  TableRow,
  TableBody,
  TextField,
  InputAdornment,
  Button,
  Grid,
  Tooltip,
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import {
  Search as SearchIcon,
  Add as AddIcon,
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  MoreVert as MoreVertIcon,
  Assignment as AssignmentIcon,
  EventNote as EventNoteIcon,
  RestaurantMenu as RestaurantIcon,
  Spa as SpaIcon,
  Hotel as HotelIcon,
  RoomService as RoomServiceIcon,
  InfoOutlined as InfoIcon,
} from '@mui/icons-material';

const StyledTableCell = styled('td')(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  fontSize: '0.8rem',
  borderBottom: '1px solid #f0f0f0',
  color: '#2e263de6',
  fontWeight: 600,
}));

const StyledTableHeadCell = styled('th')(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  fontSize: '0.75rem',
  fontWeight: 800,
  color: '#ffffff',
  backgroundColor: theme.palette.primary.main,
  borderBottom: 'none',
  textAlign: 'left',
}));

export const TabEncuestas = ({ resumen }: { resumen: any }) => {
  const misEncuestas = resumen?.topSurveys || [];

  const questionsMetrics = resumen?.questionsMetrics || [];

  console.log('questionsMetrics', questionsMetrics);

  return (
    <Grid container spacing={3}>
      {/* Encuestas con más respuestas (Top) */}
      {/*  xs={12} md={4} */}
      <Grid size={{ xs: 12, md: 4 }}>
        <Card
          sx={{
            p: 2.5,
            borderRadius: 3,
            height: '100%',
            boxShadow: '0 4px 12px rgba(0,0,0,0.03)',
            border: '1px solid #f0f0f0',
          }}
        >
          <Box
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#2e263d' }}>
              Ultimas {misEncuestas.length} encuestas con más respuestas
            </Typography>
            {/* <Typography variant="caption" sx={{ fontWeight: 700, color: 'primary.main', cursor: 'pointer' }}>Ver todas</Typography> */}
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {(resumen?.topSurveys || [])
              .slice(0, misEncuestas.length)
              .map((enc: any, index: number) => (
                <Box
                  key={index}
                  sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box
                      sx={{
                        bgcolor: alpha('#4A148C', 0.1),
                        color: '#4A148C',
                        p: 1,
                        borderRadius: 2,
                        display: 'flex',
                      }}
                    >
                      <AssignmentIcon fontSize="small" />
                    </Box>
                    <Box>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 800, color: '#2e263d', fontSize: '0.8rem' }}
                      >
                        {enc.surveyName}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ textAlign: 'right' }}>
                    <Typography variant="body2" sx={{ fontWeight: 800 }}>
                      {enc.responsesCount}
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                      respuestas
                    </Typography>
                  </Box>
                </Box>
              ))}
            {(!resumen?.topSurveys || resumen?.topSurveys.length === 0) && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ textAlign: 'center', mt: 2 }}
              >
                No hay encuestas para mostrar
              </Typography>
            )}
          </Box>
        </Card>
      </Grid>

      {/* Table Section */}
      <Grid size={{ xs: 12, md: 8 }}>
        <Card
          sx={{
            p: 0,
            borderRadius: 3,
            boxShadow: '0 4px 12px rgba(0,0,0,0.03)',
            border: '1px solid #f0f0f0',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              p: 2.5,
              borderBottom: '1px solid #f0f0f0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: 2,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 800, color: '#2e263d' }}>
                Desempeño por pregunta
              </Typography>
              <Tooltip
                title={
                  <Box sx={{ p: 1.5, maxWidth: 450 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1.5 }}>
                      Esta tabla refleja el Top 10 de los aspectos mejor evaluados por nuestros
                      clientes.
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', mb: 1.5, lineHeight: 1.5 }}>
                      Mientras que los indicadores globales (NPS, CSAT) nos dan la temperatura
                      general, esta tabla hace una radiografía detallada. Aquí estamos tomando todas
                      las encuestas que se han respondido y calculando el puntaje promedio exacto de
                      cada pregunta individual.
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', lineHeight: 1.5 }}>
                      <strong>¿Para qué nos sirve?</strong> Nos permite identificar exactamente
                      cuáles son nuestras mayores fortalezas operativas. Por ejemplo, podemos ver si
                      lo que más enamora a los clientes es 'la actitud de los meseros', 'la
                      facilidad para reservar', o 'la calidad de la comida'. Con esta data podemos
                      premiar a las áreas de mejor desempeño y saber exactamente qué estamos
                      haciendo excelente para replicarlo en otros servicios.
                    </Typography>
                  </Box>
                }
                placement="bottom-start"
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: '#2e263d',
                      color: 'white',
                      boxShadow: 3,
                      borderRadius: 2,
                    },
                  },
                }}
              >
                <IconButton
                  size="small"
                  sx={{
                    color: 'primary.main',
                    bgcolor: alpha('#4A148C', 0.05),
                    '&:hover': { bgcolor: alpha('#4A148C', 0.1) },
                  }}
                >
                  <InfoIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          <TableContainer sx={{ flexGrow: 1, overflow: 'auto' }}>
            <Table stickyHeader size="small">
              <thead>
                <tr>
                  <StyledTableHeadCell sx={{ pl: 3 }}>Pregunta</StyledTableHeadCell>
                  <StyledTableHeadCell align="center">Tipo</StyledTableHeadCell>
                  <StyledTableHeadCell align="center" sx={{ pr: 3 }}>
                    Puntaje Promedio
                  </StyledTableHeadCell>
                </tr>
              </thead>
              <tbody>
                {questionsMetrics.map((row: any, idx: number) => (
                  <tr key={idx} style={{ '&:hover': { backgroundColor: '#f9f9f9' } } as any}>
                    <StyledTableCell sx={{ pl: 3 }}>
                      <Typography variant="body2" sx={{ fontWeight: 600, color: '#2e263d' }}>
                        {row.question}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Chip
                        label={row.type}
                        size="small"
                        sx={{
                          fontWeight: 800,
                          fontSize: '0.7rem',
                          height: 22,
                          bgcolor:
                            row.type === 'NPS'
                              ? alpha('#5DCC0A', 0.1)
                              : row.type === 'CSAT'
                                ? alpha('#9C27B0', 0.1)
                                : alpha('#FF9800', 0.1),
                          color:
                            row.type === 'NPS'
                              ? '#4ba804'
                              : row.type === 'CSAT'
                                ? '#9C27B0'
                                : '#f57c00',
                        }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center" sx={{ pr: 3 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 900,
                          color:
                            row.type === 'NPS'
                              ? '#4ba804'
                              : row.type === 'CSAT'
                                ? '#9C27B0'
                                : '#f57c00',
                        }}
                      >
                        {row.score}
                      </Typography>
                    </StyledTableCell>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableContainer>
        </Card>
      </Grid>
    </Grid>
  );
};
